import { cn } from "@/lib/utils";
import type { LucideIcon } from "lucide-react";

// Soft background + matching icon ink, cycled by position so neighbouring
// tiles never share a colour (the Website 2.0 look - header menus, trigger
// cards, etc.). Each entry pairs a tone with its own ink - never mix a
// background with another tone's ink.
const tones = [
  "bg-tone-blush text-primary",
  "bg-tone-mint text-tone-mint-ink",
  "bg-tone-lilac text-tone-lilac-ink",
  "bg-tone-sun text-tone-sun-ink",
  "bg-tone-sky text-tone-sky-ink",
  "bg-tone-peach text-primary",
];

const sizes = {
  sm: { tile: "size-10 rounded-xl", icon: "size-5" },
  md: { tile: "size-11 rounded-xl", icon: "size-[22px]" },
  lg: { tile: "size-[46px] rounded-[14px]", icon: "size-[22px]" },
};

interface IconTileProps {
  icon: LucideIcon;
  index: number;
  size?: keyof typeof sizes;
}

const IconTile = ({ icon: Icon, index, size = "md" }: IconTileProps) => (
  <span
    className={cn(
      "grid shrink-0 place-items-center",
      sizes[size].tile,
      tones[index % tones.length],
    )}
  >
    {/* text-current: opts out of NavigationMenuLink's muted default icon
        colour (it targets svgs without a text-* class). */}
    <Icon
      className={cn("text-current", sizes[size].icon)}
      strokeWidth={1.8}
      aria-hidden="true"
    />
  </span>
);

export default IconTile;
